import useEnabledFeature from '../../useEnabledFeature';

const useFlexFacets = () => useEnabledFeature('cat-flex-facets');

export default useFlexFacets;
